import styled, { css } from 'styled-components'
import Box from 'components/Box'
import { ReactNode } from 'react'

export interface CardBodyProps {
  children: ReactNode
}

const CardBody = styled.div<CardBodyProps>`
  margin: 16px;
`

export interface CardProps {
  interactive?: boolean
}

const Card = styled(Box).attrs({
  __ignoreHTMLProps: ['interactive'],
})<CardProps>`
  border-radius: 3px;
  background-color: ${({ theme }) => theme.colors.text.light.base};
  transition: all
    ${({ theme }) =>
      `${theme.transitions.duration[1]} ${theme.transitions.timing.easeIn}`};
  box-shadow: ${({ theme }) => theme.shadows.boxShadow.subtle};

  ${props =>
    props.interactive &&
    css`
      &:hover,
      &:focus {
        box-shadow: ${({ theme }) => theme.shadows.boxShadow.raised};
        transform: translateY(-1px);
      }

      &:active {
        box-shadow: ${({ theme }) => theme.shadows.boxShadow.lifted};
        transform: translateY(0);
      }
    `};
`

export default Object.assign(Card, { Body: CardBody })
